<template>
    <div class="relative overflow-hidden py-2">
        <SectionWrapper borderPosition="between" type="full" id="account">
            <template #title>
                <div class="flex flex-row justify-between items-center gap-8">
                    <div class="flex flex-row justify-between w-full items-center">
                        <strong v-if="title">{{ title }}</strong>
                    </div>
                </div>
            </template>

            <template #content>
                <div v-if="data?.length" :class="'slider-' + $.uid">
                    <div class="swiper-wrapper">
                        <component :is="component" v-for="item in data" :key="item.id" :data="item" class="swiper-slide" />
                    </div>
                </div>
                <p v-else>
                    {{ $t('No Data') }}
                </p>
            </template>
        </SectionWrapper>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default {
    mounted() {
        this.init();
    },

    props: ['component', 'data', 'title', 'link', 'link_title'],

    methods: {
        init() {
            if (this.data?.length) {
                new Swiper('.slider-' + this.$.uid, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: {
                        prevEl: '.slider-button-prev-' + this.$.uid,
                        nextEl: '.slider-button-next-' + this.$.uid
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 1
                        },
                        640: {
                            slidesPerView: 1
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        1200: {
                            slidesPerView: 3
                        }
                    }
                });
            }
        }
    }
};
</script>
